
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 9 15","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true","focusable":"false"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.432 14.334V7.957h2.17l.326-2.496H5.432V3.87c0-.721.202-1.212 1.246-1.212h1.323V.432c-.23-.03-1.02-.098-1.939-.098-1.918 0-3.231 1.16-3.231 3.29V5.46H.668v2.496h2.163v6.377h2.601z","fill":"currentColor"}})])
          )
        }
      }
    